module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "uk-grid-stack",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.FilterProperties), function(property) {
    return (_vm.hasSelected(property)) ? _c('selected-shop-filter-row', _vm._g({
      key: property.id,
      attrs: {
        "property": property,
        "property-values": _vm.FilterPropertyValues[property.id],
        "selected": _vm.selectedPropertyValues[property.id]
      }
    }, _vm.$listeners)) : _vm._e()
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b354cb5","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/Filter/SelectedShopFilter.vue
// module id = 84
// module chunks = 0